var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "1em",
    height: "1em",
    viewBox: "0 -48 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.67-43.795c.302.3.451.646.451 1.038 0 .391-.149.735-.451 1.037L18.951-24.001 36.67-6.281c.302.302.451.646.451 1.037 0 .39-.149.736-.451 1.038l-2.254 2.254c-.3.3-.646.451-1.037.451-.39 0-.736-.151-1.036-.451L11.331-22.964c-.302-.3-.451-.644-.451-1.037 0-.39.149-.736.451-1.036l21.012-21.012c.3-.3.646-.451 1.036-.451.391 0 .737.151 1.037.451l2.254 2.254z",
    fillRule: "nonzero",
    stroke: "none"
  })));
}

export default SvgBack;